import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  BankPositionStatus1,
  BankPositionStatusFun,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function BankPositionStatus({ bankName, startDate, endDate }) {
  const dispatch = useDispatch();

  const { BankPositionStatusdata } = useSelector((state) => state.BankSlice);

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(BankPositionStatusFun());
    dispatch(
      BankPositionStatus1({
        Firm,
        Year: YearId,
        BankIDs: bankName.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [dispatch, Firm, bankName, YearId, startDate, endDate]);

  const getRows = BankPositionStatusdata?.Dtl?.map((label, index) => ({
    // srNumber: index + 1,
    BankName: label.BankName,
    Opening: label.Opening,
    // ChequeInHand: label.ChequeInHand,
    // ChequeIssue: label.ChequeIssue,
    ClosingBalance: label.ClosingBalance,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Bank Name",
      key: "BankName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Opening Balance",
      key: "Opening",
      align: "right",
      format: "true",
    },
    // { label: 'Receipt', key: 'ChequeInHand' },
    // { label: 'Payment', key: 'ChequeIssue' },
    {
      label: "Closing Balance",
      key: "ClosingBalance",
      align: "right",
      format: "true",
    },
  ];

  if (BankPositionStatusdata === "no" || BankPositionStatusdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            BANK POSITION STATUS
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
